const SET_STATUS_MESSAGE = 'status/SET_STATUS_MESSAGE';
const RESET_STATUS_MESSAGE = 'status/RESET_STATUS_MESSAGE';

export const STATUS_ACTION_TYPES = {
  SET_STATUS_MESSAGE,
  RESET_STATUS_MESSAGE,
};
